import React from "react";
import { IconsProps } from "./dto";

export function CalendarIcon(props: IconsProps) {

    return (
        <svg className="cursor-pointer" width={props.size} height={props.size}  onClick={(e) => props.onClick && props.onClick(e)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}